/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalReauthCaseManager
 */
export interface PalReauthCaseManager {
    /**
     * 
     * @type {string}
     * @memberof PalReauthCaseManager
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthCaseManager
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalReauthCaseManager
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalReauthCaseManager
     */
    fax?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalReauthCaseManager
     */
    email?: string | null;
}

/**
 * Check if a given object implements the PalReauthCaseManager interface.
 */
export function instanceOfPalReauthCaseManager(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function PalReauthCaseManagerFromJSON(json: any): PalReauthCaseManager {
    return PalReauthCaseManagerFromJSONTyped(json, false);
}

export function PalReauthCaseManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthCaseManager {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function PalReauthCaseManagerToJSON(value?: PalReauthCaseManager | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'phone': value.phone,
        'fax': value.fax,
        'email': value.email,
    };
}

